export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idenvironment: '',
        clave: '',
        valor: '',
        editable: 0,
        estado: 1,
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}